module.exports = __webpack_public_path__ + "img/icon_csv_blue.9b8c654f.svg";